import { WXlogin, getUserInfo, getUmList } from '@/api/user';
import { setLoginKey, getLoginKey } from '@/utils/auth';

const state = {
  loginKey: getLoginKey(),
  userInfo: {},
  roles: [],
  staffList: []
};
const mutations = {
  SET_LOGINKEY: (state, loginKey) => {
    state.loginKey = loginKey;
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_STAFF_LIST: (state, list) => {
    state.staffList = list;
  }
};
const actions =  {
  login({ commit }, userInfo) {
    localStorage.removeItem('userInfo');
    return new Promise((resolve, reject) => {
      WXlogin(userInfo).then(res => {
        if (res.errcode === 0) {
          resolve(res);
          setLoginKey(res.data.loginKey);
          commit('SET_LOGINKEY', res.data.loginKey);
        } else {
          reject(res);
        }
      }).catch((error) => {
        reject(error);
      })
    })
  },
  GetUserInof({ commit }) {
    return new Promise((resolve, reject) => {
      const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null;
      if (userInfo) {
        resolve(userInfo);
        commit('SET_USERINFO', userInfo.data);
        commit('SET_ROLES', [userInfo.data.roleId]);
      } else {
        getUserInfo().then(res => {
          if (res.errcode === 0) {
            resolve(res);
            localStorage.setItem('userInfo', JSON.stringify(res));
            commit('SET_USERINFO', res.data);
            commit('SET_ROLES', [res.data.roleId]);
          } else {
            reject(res);
            localStorage.removeItem('useInfo');
          }
        })
          .catch((error) => {
            reject(error);
          });
      }
    })
  },
  getStaffList({ commit }, params) {
    getUmList(params).then((res) => {
      if (res.errcode === 0) {
        commit('SET_STAFF_LIST', res.data)
      }
    })
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}